import React from 'react';

export const Star = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.46674 0.328125C5.56739 2.18175 4.07037 3.67877 2.21674 4.57812C4.07037 5.47748 5.56739 6.9745 6.46674 8.82812C7.36609 6.9745 8.86311 5.47748 10.7167 4.57812C8.86311 3.67877 7.36609 2.18175 6.46674 0.328125ZM20.4278 11.8641C18.2057 10.7859 16.411 8.9913 15.3329 6.76916L14.6833 5.43034L14.0337 6.76916C12.9556 8.99131 11.1609 10.7859 8.93879 11.8641L7.59997 12.5137L8.93879 13.1632C11.1609 14.2414 12.9556 16.036 14.0337 18.2582L14.6833 19.597L15.3329 18.2582C16.411 16.036 18.2057 14.2414 20.4278 13.1632L21.7666 12.5137L20.4278 11.8641ZM0.799988 18.0365C2.34468 17.287 3.59219 16.0395 4.34165 14.4948C5.09112 16.0395 6.33863 17.287 7.88332 18.0365C6.33863 18.7859 5.09112 20.0334 4.34165 21.5781C3.59219 20.0334 2.34468 18.7859 0.799988 18.0365Z"
      fill={color || '#AE7731'}
    />
  </svg>
);
